module.exports = __webpack_public_path__ + "img/rightcirclearw.3e7f678e.svg";